export default __webpack_public_path__ + "static/media/Marker.cc5f3c45.svg";